// -*- Mode: rjsx -*-
import React, { useState, useEffect } from 'react';

import { Alert, Error, archiveToast } from "../../../ui";
import { useDispatch, useSelector } from 'react-redux';

function Toaster(props) {
    
    const dispatch = useDispatch();
    
    let currentMessage = useSelector ( state => {
        return state.toaster.messages.length ? state.toaster.messages[state.toaster.messages.length - 1] : {};
    });
    
    
    function onClose(m) {
        dispatch(archiveToast(m));
    }
    
    return (
        <>
          <Alert severity={currentMessage.type}
                 open={currentMessage.date}
                 onClose={() => onClose(currentMessage) }>{currentMessage.message}</Alert>
        </>
    );

}

export default Toaster;
